<div
  class="eva-textarea"
  [class.eva-textarea--error]="error"
  [class.eva-textarea--disabled]="disabled"
  [class.eva-textarea--readonly]="readonly"
  [class.eva-textarea--focused]="isFocused"
>
  <!-- Label -->
  <label *ngIf="label" [for]="inputId" class="eva-textarea__label">
    {{ label }}<span *ngIf="required" class="eva-textarea__required">*</span>
  </label>

  <!-- Textarea -->
  <textarea
    [id]="inputId"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [attr.maxlength]="maxlength"
    [rows]="rows"
    [autocomplete]="autocomplete"
    [value]="_value"
    [style.resize]="resize"
    class="eva-textarea__field"
    [class.eva-textarea__field--compact]="rows <= 2"
    (input)="onInput($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
  ></textarea>

  <!-- Footer: Helper/Error + Count -->
  <div *ngIf="helper || error || showCount" class="eva-textarea__footer">
    <small *ngIf="helper && !error" class="eva-textarea__helper">
      {{ helper }}
    </small>
    <small *ngIf="error" class="eva-textarea__error-text">
      {{ error }}
    </small>
    <small
      *ngIf="showCount"
      class="eva-textarea__count"
      [class.eva-textarea__count--warning]="maxlength && _value.length >= maxlength * 0.9"
    >
      {{ characterCount }}
    </small>
  </div>
</div>
